import Super from '@simplepractice/ember-messaging-client/adapters/messaging-base';

export default Super.extend({});
